import { useStaticQuery, graphql } from "gatsby"

const ALL_AIRTABLE_FMR_FIELDS_QUERY = graphql`
  query {
    allAirtableallFlexmedReimburseFormFields(
      filter: {
        data: {
          Show_On_Website: { eq: true }
          Product: { eq: "FlexMed Reimburse" }
        }
      }
    ) {
      nodes {
        data {
          Name
          Type
          Initial_Values
          Field_Names
          Module
          Show_On_Website
          Zendesk_Key
          Show_On_Zendesk
          Zendesk_Order
        }
      }
    }
  }
`

export const useAirtableFMRFormFields = () => {
  const data = useStaticQuery(ALL_AIRTABLE_FMR_FIELDS_QUERY)

  return data
}
